import { Component, OnInit, Input, Output, EventEmitter, AfterViewChecked } from '@angular/core';
import { Attending } from '../../../model/attending';
import { DiagnosisWebSocketService } from '../../../../diagnosis/service/diagnosis-web-socket.service';
import { VehicleService } from '../../../../diagnosis/service/vehicle.service';
import { Vehicle } from '../../../../shared/model/vehicle';
import { AuthenticationService } from '../../../../shared/service/authentication.service';
import { MaterializeAction } from 'angular2-materialize';
import { AttendingScore } from '../../../model/attending-score';
import { AttendingType } from '../../../constants/attending-type';
import { MonitoringStepStatus } from '../../../constants/monitoring-step-status';
import { MonitoringStepType } from '../../../constants/monitoring-step-type';
import {AttendingService} from "../../../service/attending.service";

declare var Materialize: any;

@Component({
  selector: 'tx-monitoring',
  templateUrl: './monitoring.component.html',
  styleUrls: ['./monitoring.component.css']
})
export class MonitoringComponent implements OnInit, AfterViewChecked {
  private _attending: Attending = new Attending();
  @Input() editable: boolean;
  @Output() txOnUpdateMonitoring: EventEmitter<any> = new EventEmitter();
  @Output() txOnCancel: EventEmitter<any> = new EventEmitter();
  @Output() txOnAssignMonitoringToUser: EventEmitter<any> = new EventEmitter();
  @Output() txOnUnassignMonitoringToUser: EventEmitter<any> = new EventEmitter();
  @Output() txOnUpdateAttendingInfo: EventEmitter<any> = new EventEmitter();
  @Output() txOnConvertAttending: EventEmitter<any> = new EventEmitter();

  files = new Array();
  modalActions = new EventEmitter<string|MaterializeAction>();
  attendingInfoPolling = null;
  vehicle: Vehicle;
  authenticatedUser: any;
  MONITORING = 'MONITORING';
  attendingIsAuditOrMaintenance = false;
  conversionButtonText = '';

  constructor(private _diagnosisNotification: DiagnosisWebSocketService,
              private _vehicleService: VehicleService,
              private _authService: AuthenticationService,
              private _attendingService: AttendingService) {
    this.setEmptyEntities();
  }

  ngAfterViewChecked() {
    try {
      Materialize.updateTextFields();
    } catch (e) { }
  }

  get attending() {
    return this._attending;
  }

  @Input()
  set attending(attending) {
    this._attending = {
      ...attending,
      attendingInfo: {
        ...attending.attendingInfo
      }
    };
    this.authenticatedUser = this._authService.getUserFromLocalStorage();
    this.setUpObservers();
    this.showStep();
    this.attendingIsMaintenanceOrAudit();
    this.tryUpdateAttendingInfo();
    this.setEmptyEntities();
  }

  ngOnInit() {
  }

  cancel() {
    this.txOnCancel.emit(this.attending);
  }

  canEdit() {
    return (this.attending.monitoring.canEdit || this.attending.monitoring.canEdit === undefined) && this.editable;
  }

  canView() {
    return this.attending.monitoring.canView && !this.canEdit();
  }

  isUserAssigned() {
    try {
      return this.attending.monitoring.argosUser.id === this.authenticatedUser.id;
    } catch (e) {
      return false;
    }
  }

  assignToMe() {
    this.attending.monitoring.argosUser = this.authenticatedUser;
    this.txOnAssignMonitoringToUser.emit();
  }

  unassignToMe() {
    this.attending.monitoring.argosUser = {};
    this.txOnUnassignMonitoringToUser.emit();
  }

  rescheduleAttending() {
    this._attendingService.reschedule(this._attending.id);
  }

  attendingIsMaintenanceOrAudit() {
    if (this.attending) {
      this.attendingIsAuditOrMaintenance =
        (this.attending.type === AttendingType.AUDIT || this.attending.type === AttendingType.MAINTENANCE)
        && this.attending.attendingInfo.conversion && !this.attending.attendingInfo.conversion.converted;
      if (this.attendingIsAuditOrMaintenance) {
        this.conversionButtonText =
          this.attending.attendingInfo.conversion.type === AttendingType.AUDIT ? 'TRANSFORMAR EM AUDITORIA' : 'TRANSFORMAR EM MANUTENÇÃO';
      }
    }
  }

  displayStep(type) {

    if (type === MonitoringStepType.PRE_EVALUATION) {
      return this._attending.monitoring.preEvaluationStep === MonitoringStepStatus.CURRENT;
    } else if (type === MonitoringStepType.VALIDATION) {
      return this._attending.monitoring.validationStep === MonitoringStepStatus.CURRENT;
    } else if (type === MonitoringStepType.CONCLUSION) {
      return this._attending.monitoring.conclusionStep === MonitoringStepStatus.CURRENT;
    }

    return false;
  }

  private setEmptyEntities() {
    try {
      this.attending.technicianScore = this.attending.technicianScore || new AttendingScore();
    } catch (e) { }
  }

  private tryUpdateAttendingInfo() {
    if (this.canEdit() && !this.attendingInfoPolling) {
      this.attendingInfoPolling = setInterval(() => {
        if (this.attending) {
          this.emitAttendingInfoUpdateRequest();
        }
      }, 20000);
    }
  }

  private emitAttendingInfoUpdateRequest() {
    this.txOnUpdateAttendingInfo.emit(this.attending.attendingInfo.id);
  }

  private showStep() {
    if (this.attending.orderedSteps && this.attending.currentStep === this.MONITORING) {
      this.setIsVisible();
      this.setIsEditable();
    }
  }

  private setIsVisible() {
    if (this.attending.orderedSteps.includes(this.MONITORING)
        && this.authenticatedUser.stepViews.find(view => view.stepViewType === this.MONITORING)) {
      this.attending.monitoring.canView = true;
    } else {
      this.attending.monitoring.canView = false;
    }
  }

  private setIsEditable() {
    if (this.authenticatedUser.stepKeys.find(view => view.stepType === this.MONITORING)) {
      this.attending.monitoring.canEdit = true;
    } else {
      this.attending.monitoring.canEdit = false;
    }
  }

  private setUpObservers() {
    if (this.canEdit()) {
      this._vehicleService.find$
      .subscribe(vehicles => {
        this.vehicle = vehicles.find(vehicle => vehicle.plate === this.attending.vehiclePlate);
      });
    }
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/attending/component/monitoring/monitoring/monitoring.component.ts